<template>
  <div class="game">
    <div class="game__stage" v-if="!image">
      <VText small center>Pokaż nam gdzie i jak oglądasz Przyjaciół na Comedy Central. Na zdjęciu powinien być widoczny serial oglądany na naszym kanale, ale cała reszta należy do Ciebie. Zaskocz nas!</VText>

      <label class="game__file">
        <VButton>Wybierz zdjęcie</VButton>

        <input type="file" @change="onFileChange($event.target.files)" accept="image/png, image/jpeg" />
      </label>
    </div>

    <div class="game__stage" v-if="image">
      <VText small center>
        Teraz wybierz ramkę dla swojego zdjęcia.<br />
        Możesz również zmienić pozycję zdjęcia lub jego rozmiar - użyj kółka myszy<br />
        lub gestów na ekranie dotykowym.
      </VText>

      <div class="game__main">
        <div class="game__wrapper" ref="wrapper">
          <canvas ref="view" width="460" height="460" />
        </div>

        <a href="" class="game__button game__button--prev" @click.prevent="changeFrame(-1)"></a>
        <a href="" class="game__button game__button--next" @click.prevent="changeFrame(1)"></a>
      </div>

      <!-- <VBlock class="game__photo" max-width="460px" v-if="image">
        <img :src="image" />
      </VBlock> -->

      <VBlock max-width="460px" v-if="!isUploading">
        <VButton @click="end()">Zapisz!</VButton>
      </VBlock>
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import { Viewport } from 'pixi-viewport';
import dataURLtoBlob from 'blueimp-canvas-to-blob';

export default {
  name: 'VGame',

  data: () => ({
    file: undefined,
    image: undefined,
    isUploading: false,
    currentFrameIndex: 0, // Track the current frame index
    app: undefined,
    frames: [], // To store the frames
    framesContainer: null, // To store the container for frames
  }),

  methods: {
    setupPixi() {
      const photo = new PIXI.Sprite(PIXI.Texture.from(this.image));

      photo.texture.baseTexture.on('loaded', () => {
        const app = new PIXI.Application({
          view: this.$refs.view,
          width: 460,
          height: 460,
          backgroundColor: 0xffffff,
        });

        this.app = app;

        const viewport = new Viewport({
          screenWidth: 460,
          screenHeight: 460,
          worldWidth: photo.width,
          worldHeight: photo.height,
          divWheel: this.$refs.wrapper,
          events: app.renderer.events,
          interaction: app.renderer.plugins.interaction,
          passiveWheel: false,
        });

        app.stage.addChild(viewport);
        viewport.addChild(photo);

        viewport
          .fit()
          .drag()
          .pinch()
          .wheel({ percent: 0.3 })
          .clamp({ direction: 'all' });

        this.framesContainer = new PIXI.Container();
        app.stage.addChild(this.framesContainer);

        const framesImages = [
          '/frame-00.png',
          '/frame-01.png',
        ];

        this.frames = framesImages.map((frameImage) => new PIXI.Sprite(PIXI.Texture.from(frameImage)));

        this.frames.forEach((frame, index) => {
          frame.width = 460;
          frame.height = 460;
        });


        this.framesContainer.addChild(this.frames[0]); // Initially add the first frame
      });
    },

    changeFrame(direction) {
      // Remove the current frame from the container
      this.framesContainer.removeChild(this.frames[this.currentFrameIndex]);

      // Update the frame index (loop around if necessary)
      this.currentFrameIndex += direction;
      if (this.currentFrameIndex >= this.frames.length) {
        this.currentFrameIndex = 0;
      } else if (this.currentFrameIndex < 0) {
        this.currentFrameIndex = this.frames.length - 1;
      }

      // Add the new frame to the container
      this.framesContainer.addChild(this.frames[this.currentFrameIndex]);
    },

    onFileChange([file] = []) {
      const hasFile = !!file;

      if (!hasFile || this.isUploading) {
        return;
      }

      this.file = file;
      this.image = URL.createObjectURL(file);

      this.$nextTick(() => {
        this.setupPixi();
      });
    },

    async end() {
      this.isUploading = true;

      this.app.renderer.render(this.app.stage);

      const photo = this.app.renderer.view.toDataURL('image/png');
      const file = dataURLtoBlob(photo);
      const attachment = await this.$bricodes.uploadFile(file);

      console.log(attachment);

      this.$emit('end', {
        attachment,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game {
  &__main {
    position: relative;
  }

  &__button {
    position: absolute;

    top: 50%;
    width: 50px;
    height: 50px;

    transform: translateY(-50%);

    background-color: #f8c500;
    background-image: url('~@/assets/icon-back.png');
    background-size: 80% auto;
    background-repeat: no-repeat;
    background-position: center center;

    box-shadow: 8px 8px #000000;
    cursor: pointer;

    &:hover {
      background-color: #000000;
    }

    &--prev {
      background-image: url('~@/assets/icon-arrow-left.png');

      &:hover {
        background-image: url('~@/assets/icon-arrow-left-hover.png');
      }
    }

    &--next {
      right: 0;
      background-image: url('~@/assets/icon-arrow-right.png');

      &:hover {
        background-image: url('~@/assets/icon-arrow-right-hover.png');
      }
    }
  }

  &__wrapper {
    width: 100%;
    max-width: 460px;
    margin: $gridGutter auto 0;
    cursor: move;

    box-shadow: 8px 8px #000;

    canvas {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
  }

  &__photo {
    margin-top: $gridGutter !important;
    box-shadow: 8px 8px #000;
  }

  &__file {

    position: relative;

    display: block;
    margin-top: $gridGutter;
    max-width: 460px;
    margin: $gridGutter auto;

    input[type='file'] {
      position: absolute;
      left: -9999px;
    }
  }
}
</style>
